import { jsx, jsxs } from 'react/jsx-runtime';
import { styled } from '@mui/material';
import { BrandclubProductCard } from '../components/BrandclubProductCard/index.js';
import BrandclubLoading from '../components/BrandclubLoading/index.js';
import { ProductGrid } from './SearchResultsStyles.js';

const Container = styled('div')({});
const SearchProductGrid = ({ loading, products, LinkComponent, containerWidthOverride, onShareClick, children, }) => {
    return (jsx(Container, { children: loading ? (jsx(BrandclubLoading, { type: "productGrid" })) : (jsxs(ProductGrid, Object.assign({ className: "grid", containerWidthOverride: containerWidthOverride }, { children: [children, products.map((product, idx) => {
                    return (jsx(BrandclubProductCard, { className: "fullsize_responsive", LinkComponent: LinkComponent, onShareClick: (e) => onShareClick(e, product), product: product }, idx));
                })] }))) }));
};

export { SearchProductGrid as default };
//# sourceMappingURL=SearchProductGrid.js.map
